const adsenseLazyLoad = (elem) => {

	const adsWrap = elem;
	
	if (!adsWrap) return;
  
	for (let i = 0; i < adsWrap.length; i++) {
		const adsWrapItem = adsWrap[i];
		const ins = adsWrapItem.firstElementChild;

		if (!ins) continue;
		if (ins.tagName !== 'INS') continue;

		const scriptSorceTag = document.createElement('script');
		const scriptTag = document.createElement('script');

		scriptTag.innerHTML = '(adsbygoogle = window.adsbygoogle || []).push({})';

		const adSrc = adsWrapItem.getAttribute('data-adsrc');
		scriptSorceTag.src = adSrc;
	
		adsWrapItem.insertBefore(scriptSorceTag, adsWrapItem.firstChild);
		adsWrapItem.appendChild(scriptTag);
	}
}
const adsenseLazyLoadAll = () => {
	const adsWrap = document.getElementsByClassName('adsense-wrap');
	const infeedAd = document.getElementsByClassName('infeed-ad');
  
	try {
		adsenseLazyLoad(adsWrap);
		adsenseLazyLoad(infeedAd);
	} catch (error) {
		// console.log(error);
	}
}
window.addEventListener('scroll', adsenseLazyLoadAll, { once: true });